var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25rem",
    height: "1.25rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m18f6mny9a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 553",
    style: {
      strokeWidth: 0
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61681"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11274",
    style: {
      clipPath: "url(#m18f6mny9a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61585"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9393",
    d: "M-1626.816 909.611a5.351 5.351 0 0 0 2.41-.583 5.1 5.1 0 0 0 1.2-.87.556.556 0 0 0 .078-.069 5.209 5.209 0 0 0 1.531-3.689 4.779 4.779 0 0 0-.087-.94 4.654 4.654 0 0 0-.479-1.409 5.2 5.2 0 0 0-4.654-2.88 5.229 5.229 0 0 0-5.219 5.22 5.171 5.171 0 0 0 1.531 3.688 5.2 5.2 0 0 0 3.689 1.532zm-2.462-7.673a3.443 3.443 0 0 1 2.462-1.026 3.509 3.509 0 0 1 3.123 1.949 3.486 3.486 0 0 1 .356 1.54c0 .087 0 .174-.009.261l-.009.009a3.312 3.312 0 0 1-.487 1.531 3.5 3.5 0 0 1-1.331 1.261 3.462 3.462 0 0 1-1.644.409 3.484 3.484 0 0 1-2.462-1.018 3.484 3.484 0 0 1-1.018-2.462 3.466 3.466 0 0 1 1.019-2.454z",
    transform: "translate(1636.815 -898.306)",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9394",
    d: "M-1621.83 914.068a4.287 4.287 0 0 0-2.636-.9h-5.22a4.351 4.351 0 0 0-4.35 4.35v1.74h1.74v-1.74a2.612 2.612 0 0 1 2.61-2.61h5.22a2.578 2.578 0 0 1 1.714.644 2.607 2.607 0 0 1 .9 1.966v1.74h1.74v-1.74a4.394 4.394 0 0 0-.469-1.966 4.288 4.288 0 0 0-1.249-1.484z",
    transform: "translate(1637.075 -900.127)",
    style: {
      strokeWidth: 0
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/AdminIcon.e428450495d1c7fac2e1130a250acbb4.svg";
export { ForwardRef as ReactComponent };